import cx from 'classnames'

import { useSelectButtonEvent } from '@/core/analytics/hooks'

import { Icon } from '../../Icon'

import { StyledButton } from '../styles'
import type { SharingButton } from '../types'
import { useGenerateSharerUrl } from '../utils'

const ButtonWithIcon = ({
  buttonIcon,
  iconWidth = '24',
  iconHeight = '24',
  sharerUrl,
  accessibleLabel,
  handleOnClick,
}: SharingButton) => {
  const selectButtonEvent = useSelectButtonEvent()
  const sharerUrlWithPageUrl = useGenerateSharerUrl({ sharerUrl })
  const openNewTabProps = !!sharerUrl && { target: '_blank', rel: 'noopener noreferrer' }
  const elementType = sharerUrl ? 'a' : 'button'

  const onClick = () => {
    selectButtonEvent({ label: accessibleLabel })
    if (elementType === 'button') handleOnClick()
  }

  return (
    <StyledButton
      href={sharerUrlWithPageUrl}
      icon={buttonIcon}
      as={elementType}
      role={elementType === 'a' ? 'button' : undefined}
      className={cx({ [`--${buttonIcon}`]: buttonIcon })}
      aria-label={accessibleLabel}
      onClick={onClick}
      {...openNewTabProps}
    >
      <Icon
        icon={buttonIcon}
        width={iconWidth}
        height={iconHeight}
        svgProps={{ viewBox: '0 0 512 512' }}
      />
    </StyledButton>
  )
}

export default ButtonWithIcon
